
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartArchipelagicSeaLanes as ObiChartArchipelagicSeaLanesElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-archipelagic-sea-lanes.js';
 
 
 

 
 export const ObiChartArchipelagicSeaLanes = createComponent({
   react: React,
   tagName: 'obi-chart-archipelagic-sea-lanes',
   elementClass: ObiChartArchipelagicSeaLanesElement,
   events: {
     
   }
  });
 
 